import React from 'react';
import { Badge } from 'react-bootstrap';
import DataTable from '../common/DataTable';

const UserList = ({ users, loading }) => {
  const headers = [
    { label: 'Name' },
    { label: 'Username/Phone' },
    { label: 'Role' }
  ];

  return (
    <DataTable 
      headers={headers}
      data={users}
      loading={loading}
      emptyMessage="No system users found."
      renderRow={(u) => (
        <tr key={u._id}>
          <td className="align-middle font-weight-bold">{u.name}</td>
          <td className="align-middle small text-muted">
            {u.username && <div><i className="fas fa-user mr-2"></i>{u.username}</div>}
            {u.phone && <div><i className="fas fa-phone mr-2"></i>{u.phone}</div>}
            {!u.username && !u.phone && '-'}
          </td>
          <td className="align-middle">
            <Badge variant={u.type === 'admin' ? 'danger' : 'info'} className="text-uppercase" style={{ fontSize: '0.7rem' }}>
              {u.type}
            </Badge>
          </td>
        </tr>
      )}
    />
  );
};

export default UserList;
